module.exports = __webpack_public_path__ + "img/pc-template-category-advert.a72698ba.jpg";